import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const factorMainStatus = async () => axios.get(Routes.FACTOR_MAIN_STATUS);

export const useFactorMainStatus = () =>
  useQuery({
    queryKey: [Keys.FACTOR_MAIN_STATUS_QRY],
    queryFn: factorMainStatus,
  });
